import React from 'react';

import RolesTable from '../components/tables/RolesTable';

const SettingsRolesPage: React.FC = () => <RolesTable />;

export default SettingsRolesPage;
